<template>
<v-container fluid>
 <v-snackbar
  v-model="snackbar"
  :color="snackbarColor"
  :top="true"
  :right="true"
  :timeout="6000"
  absolute
  >
  {{ message }}
  <v-btn
    dark
    flat
    @click="snackbar = false"
  >
    CLOSE
  </v-btn>
</v-snackbar>
<v-layout mt-5>
<v-flex xs12>
  <div :class="paginatedItems.length === 5 ? 'approvesettlements_box' : 'approvesettlements_box_empty'">
    <v-card-text>
    <h5 class="accent--text" style="font-size: 12px; font-weight:700"> Pending Settlements </h5>
    <table class="table">
      <thead class="thead">
        <tr>
          <th scope="col">Transaction ID</th>
          <!-- <th scope="col">Eslip</th> -->
          <!-- <th scope="col">Eslip amount</th> -->
          <th scope="col">Amount Paid</th>
          <th scope="col">Narration</th>
          <th scope="col">Transaction Date</th>
          <th scope="col">Currency</th>
          <th scope="col">Account</th>
          <th scope="col">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in paginatedItems" v-bind:key="item.id">
          <td> {{ item.transactionID }} </td>
          <!-- <td>{{ item.eslip.eslipNumber }}</td> -->
          <!-- <td>{{ item.eslip.eslipAmount }}</td> -->
           <td>{{ item.amount }}</td>
          <td>{{ item.narration }}</td>
          <td>{{ item.created | prettyDate }}</td>
          <td>{{ item.currency }}</td>
          <td>{{ item.accountNumber }}</td>
          <td class="actions">
            <v-btn @click="getSettlementDetails(item, 'approve')"> Approve </v-btn>
            <v-btn @click="getSettlementDetails(item, 'reject')"> Reject </v-btn>
          </td>
        </tr>
      </tbody>
    </table>
    </v-card-text>
    <v-card-actions>
      <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
      <v-spacer></v-spacer>
      <v-pagination
      v-model="page"
      :length="numberOfLinks"
      :total-visible="7"
      color="secondary"
                class="accent--text logoutbtn"
    ></v-pagination>
    </v-card-actions>
  </div>
</v-flex>
<v-dialog v-model="approveDialog" max-width="850" persistent>
  <v-card>
    <v-card-title class="title accent--text text-capitalize">
      Approve DSS Settlement
    </v-card-title>
    <v-card-text>
       <table class="table">
        <thead class="thead">
          <tr>
            <th scope="col">EslipNumber</th>
             <th scope="col">Eslip Amount</th>
             <th scope="col">Buyer</th>
         
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in paginatedSettlements" v-bind:key="item.id">
            <td> {{ item.eslipNumber }} </td>
            <td> {{ item.eslipAmount }} </td>
            <td> {{ item.buyer.organisationName }} </td>

          </tr>
        </tbody>
      </table>
    </v-card-text>
    <v-card-actions>
      <span class="paginationtext"> Showing {{ sPage }} of {{ numberOfLinks }} pages </span>
      <v-spacer></v-spacer>
      <v-pagination
      v-model="sPage"
      :length="numberOfLinks"
      :total-visible="7"
      color="secondary"
                class="accent--text logoutbtn"
    ></v-pagination>
    </v-card-actions>
    <v-card-actions>
      <v-btn color="secondary" flat @click="closeApproveDialog"> Close </v-btn>
      <v-spacer> </v-spacer>
      <v-btn color="secondary" round @click="approveSettlement"> Approve </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
<v-dialog v-model="declineDialog" max-width="700" persistent>
  <v-card>
    <v-card-title class="title accent--text text-capitalize">
      Decline DSS Settlement
    </v-card-title>
    <v-card-text>
       <table class="table">
        <thead class="thead">
          <tr>
            <th scope="col">EslipNumber</th>
             <th scope="col">Eslip Amount</th>
             <th scope="col">Buyer</th>
         
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in paginatedSettlements" v-bind:key="item.id">
            <td> {{ item.eslipNumber }} </td>
            <td> {{ item.eslipAmount }} </td>
            <td> {{ item.buyer.organisationName }} </td>

          </tr>
        </tbody>
      </table>
    </v-card-text>
    
    <v-card-actions>
      <v-btn color="secondary" flat @click="closeDeclineDialog"> Close </v-btn>
      <v-spacer> </v-spacer>
      <v-btn color="secondary" round @click="declineSettlement"> Decline </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</v-layout>
</v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'

export default {
  name: 'approvesettlements',
  data: function () {
    return {
      message: '',
      snackbar: false,
      snackbarColor: '',
      loading: false,
      search: '',
      permissions: [],
      results: [],
      totalResults: 0,
      paginatedItems: [],
      paginatedSettlements: [],
      matchedEslips:[],
      numberOfLinks: 0,
      sNumberOfLinks: 0,
      numberOfItemsPerPage: 10,
      page: 1,
      sPage: 1,
      approveDialog: false,
      settlementdetails: [],
      payment: {},
      declineDialog: false
    }
  },
  mounted () {
    this.getReceivedPayments()
    // eslint-disable-next-line
    // this.results = [{'id': 1, 'transactionId': 'IB116bd6f6b7f45NKH', 'narration': '', 'amount': '10000', 'transactionDate': '2019-07-09T16:40:21.578+03:00', 'currency': 'KES', 'xRate': 1 }]
  },
  watch: {
    results: function () {
      this.numberOfLinks = Math.ceil(this.results.length / this.numberOfItemsPerPage)
      this.paginatedItems = this.paginationMethod(this.results, 1, this.numberOfItemsPerPage)
    },
    page: function (val) {
      this.paginatedItems = this.paginationMethod(this.results, val, this.numberOfItemsPerPage)
    },
    settlementdetails: function () {
      this.sNumberOfLinks = Math.ceil(this.settlementdetails.length / this.numberOfItemsPerPage)
      this.paginatedSettlements = this.paginationMethod(this.settlementdetails, 1, this.numberOfItemsPerPage)
    },
    sPage: function (val) {
      this.paginatedSettlements = this.paginationMethod(this.settlementdetails, val, this.numberOfItemsPerPage)
    }
  },
  computed: {
  },
  methods: {
    closeApproveDialog () {
      this.approveDialog = false
      this.settlementdetails = []
    },
    closeDeclineDialog () {
      this.declineDialog = false
      this.settlementdetails = []
    },
    paginationMethod (items, pageNumber, limitPerPage) {
      pageNumber = pageNumber - 1
      const from = pageNumber * limitPerPage
      let to = (pageNumber + 1) * limitPerPage
      if (to >= items.length) {
        to = items.length
      }
      return items.slice(from, to)
    },
    getReceivedPayments () {
      const url = config.serverURI + '/payment/unapprovedpayments'
      axios.get(url)
        .then(response => {
          console.log('Unapproved Payments',response.data)
          this.results = response.data
        })
        .catch(error => {
          console.log('error', error.response)
        })
      return this.results
    },
    getSettlementDetails (item, requestType) {
      const url = config.serverURI + '/settlement/transactions'
      axios.post(url, item)
        .then(response => {
          console.log('Response At Transaction get', response.data)
          this.settlementdetails = response.data
          this.payment = item
          if (requestType === 'approve') {
            console.log('Request Type', requestType)
            this.approveDialog = true
            console.log('Approve Dialog', this.approveDialog)
          } else {
            this.declineDialog = true
          }
        })
        .catch(error => {
          console.log('error', error.response)
          this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status
          this.snackbar = true
          this.snackbarColor = 'error'
        })
    },
    approveSettlement () {
      const url = config.serverURI + '/settlement/approve'
      this.payment.settlementTransactions = this.settlementdetails
      console.log(this.payment)
      axios.post(url, this.payment)
        .then(response => {
          this.snackbar = true
          this.snackbarColor = 'success'
          this.message = response.data.message
          this.getReceivedPayments()
          this.closeApproveDialog()
        })
        .catch(error => {
          console.log('error', error.response)
          this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status
          this.snackbar = true
          this.snackbarColor = 'error'
        })
    },
    declineSettlement () {
      const url = config.serverURI + '/settlement/decline'
      this.payment.settlementTransactions = this.settlementdetails
      axios.post(url, this.payment)
        .then(response => {
          this.snackbar = true
          this.snackbarColor = 'success'
          this.message = response.data.message
          this.getReceivedPayments()
          this.closeDeclineDialog()
        })
        .catch(error => {
          console.log('error', error.response)
          this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status
          this.snackbar = true
          this.snackbarColor = 'error'
        })
    }
  }
}

</script>
<style>
.mytable .v-table tbody tr:not(:last-child) {
    border-bottom: none;
}
.approvesettlements_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}
.approvesettlements_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}
.approvesettlements_box:after, .approvesettlements_box:before {
  right: 100%;
  top: 80%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.approvesettlements_box:after {
  border-color: rgba(255, 255, 255, 0);
  border-right-color: #fff;
  border-width: 20px;
  margin-top: -20px;
}
.approvesettlements_box:before {
  border-color: rgba(112, 112, 112, 0);
  border-right-color: #707070;
  border-width: 21px;
  margin-top: -21px;
}

.table  tbody  tr >  td.actions {
  font-size: 10px !important;
  color: #733D29 !important;
  text-align:center;
  vertical-align: middle;
  padding-top: 0px;
  height: 10px;
}

</style>
